// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__5WV-7","title":"AfterBackImages_title__1uCGj","images":"AfterBackImages_images__3WoWx"};